import { defineChain } from 'viem'
 
export const Test_CoreDao = defineChain({
  id: 1114,
  name: 'Core Testnet 2',
  nativeCurrency: {
    decimals: 18,
    name: 'tCore2',
    symbol: 'tCORE2',
  },
  rpcUrls: {
    default: {
      http: ['https://rpc.test2.btcs.network'],
      //webSocket: ['wss://rpc.zora.energy'],
    },
  },
  blockExplorers: {
    default: { name: 'Explorer', url: 'https://scan.test2.btcs.network/' },
  },
  /*contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
      blockCreated: 5882,
    },
  },*/
})